<template>
    <div class="pop_overay">
        <div class="pop_cont">
            <img @click="closeBtn" class="close_icon_admin" src="@/assets/images/close.png" alt="close">
            <img class="icon_img" src="@/assets/images/popup_icon.png" alt="icon">
            <div class="text_2">
                <div class="noti_txt">
                  <h3>{{ info.gift_popup.mingle_popup_title }}</h3>
                  <p v-html="info.gift_popup.mingle_popup_content"></p>
                </div>
            </div>
            <button v-if="fstTit" :class="scdTit ? 'type1' : ''" @click="viewDetail(fstUrl)">{{ fstTit }}</button>
            <button v-if="scdTit" class="type2" @click="viewDetail(scdUrl)">{{ scdTit }}</button>
        </div>
    </div>
</template>
<script>
import * as appEvent from '@/assets/js/app_event.js'
import { mapState } from 'vuex'
export default {
  name: 'PopupGiftApi',
  props: {
    info: Object
  },
  data () {
    return {
      fstTit: this.info.gift_popup.mingle_popup_url_fst_tilte,
      fstUrl: this.info.gift_popup.mingle_popup_fst_url,
      scdTit: this.info.gift_popup.mingle_popup_url_scd_title,
      scdUrl: this.info.gift_popup.mingle_popup_url_scd_url
    }
  },
  computed: {
    ...mapState(['popCustomApi'])
  },
  methods: {
    closeBtn () {
      this.$store.state.popCustomApi = false
      this.$store.dispatch('openPopupGift', {})
    },
    viewDetail (url) {
      appEvent.externalLinks(url)
    }
  },
  mounted () {
  }
}
</script>
